/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import is from 'is_js';
// $FlowFixMe
import BigNumber from 'bignumber.js';

import type { Curreny } from '../reducers/exchange';
import type { UserConfig } from '../reducers/users';
import { DASH, formatNumber, decMultiply } from '../utils/number';

const CNY = 'CNY';
const USD = 'USD';
const ACCURANCY_DECIMAL = 6;
const GROSS_DECIMAL = 2;

const mapStateToProps = ({
  locale, currencyList, fiatRate, userPreferredCurrency,
}) => ({
  locale,
  currencyList,
  fiatRate,
  preferredCurrency: userPreferredCurrency,
});

type ComponentProps = {
  prefix: string,
  locale: string,
  fiatRate: Object,
  fiatRateWithCurrency?: Object,
  quoteAsset: string,
  precision?: number,
  price: string,
  color?: string,
  currencyList?: Curreny[],
  preferredCurrency?: UserConfig,
};

type FiatPriceProps = {
  prefix?: string,
  locale: string,
  currencyList: Curreny[],
  fiatRateWithCurrency?: Object,
  fiatRate: Object,
  quoteAsset: string,
  precision?: number,
  preferredCurrency?: string,
  price: string,
  preferredCurrency?: UserConfig,
  color?: string,
};
type ShowData = {
  prefixStr: string,
  symbol: string,
  calculatedprice: string,
  unit: string,
};

export default
@connect(mapStateToProps)
class StyledFiatPrice extends React.Component<ComponentProps> {
  static defaultProps = {
    prefix: '',
    locale: 'en',
    fiatRate: {},
    precision: 2,
    currencyList: [],
    color: undefined,
    preferredCurrency: undefined,
  };

  render() {
    const {
      price,
      quoteAsset,
      precision,
      locale,
      currencyList,
      fiatRate,
      prefix,
      preferredCurrency,
      fiatRateWithCurrency,
      color,
    } = this.props;
    return (
      <FiatPrice
        prefix={prefix}
        locale={locale}
        currencyList={currencyList || []}
        fiatRate={fiatRate}
        fiatRateWithCurrency={fiatRateWithCurrency || {}}
        quoteAsset={quoteAsset}
        precision={precision}
        price={price}
        preferredCurrency={preferredCurrency}
        color={color}
      />
    );
  }
}
export const getFiatPrice = (props: Object): ShowData | null => {
  const {
    currencyList, locale, price, quoteAsset, prefix, preferredCurrency, fiatRate,
  } = props;

  let currency;
  if (preferredCurrency && preferredCurrency.configName) {
    const currencyName = preferredCurrency.configName.split('_')[0];
    currency = currencyList.find(c => c.name === currencyName);
  } else if (locale === 'cn' && Array.isArray(currencyList)) {
    currency = currencyList.find(c => c.name === CNY);
  }
  currency = currency || (currencyList && currencyList.find(c => c.name === USD));
  if (is.undefined(fiatRate) || is.undefined(fiatRate[quoteAsset]) || is.undefined(price)) {
    return null;
  }
  const prefixStr = is.undefined(prefix) ? '' : prefix || '';
  const rate = currency && currency.rate ? currency.rate : 1;
  const sum = BigNumber(price).multipliedBy(BigNumber(fiatRate[quoteAsset])).toFixed(ACCURANCY_DECIMAL); // TODO
  const fiatPrice = decMultiply(
    ACCURANCY_DECIMAL,
    sum,
    rate
  );
  const precision = Number(fiatPrice) > 1 ? GROSS_DECIMAL : ACCURANCY_DECIMAL;
  const calculatedprice = formatNumber(fiatPrice, precision);
  const symbol = currency ? currency.symbol : '$';
  const unit = currency ? currency.name : 'USD';

  return {
    prefixStr,
    symbol,
    calculatedprice,
    fiatPrice,
    unit,
  };
};

export const FiatPrice = (props: FiatPriceProps) => {
  const data = getFiatPrice(props);
  if (data === null) {
    return <span>{DASH}</span>;
  }
  const { prefixStr, symbol, calculatedprice } = data;

  return (
    <span style={{ color: props.color }}>
      {prefixStr}
      {symbol}
      {calculatedprice}
    </span>
  );
};
export const FiatPriceWithUnit = (props: FiatPriceProps) => {
  const data = getFiatPrice(props);
  if (data === null) {
    return <span>{DASH}</span>;
  }
  const { prefixStr, calculatedprice, unit } = data;

  return (
    <span className="fiat-price">
      <span className="prefix-str">{prefixStr}</span>
      <span className="calculated-price">{calculatedprice}</span>
      <span className="quote-asset"> {unit}</span>
    </span>
  );
};
FiatPrice.defaultProps = {
  prefix: '',
  precision: 2,
  preferredCurrency: undefined,
};
FiatPriceWithUnit.defaultProps = {
  prefix: '',
  precision: 2,
  preferredCurrency: undefined,
};
